<!--
 * @Description: iief5
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-04 17:58:05
 -->

<template>
      <v-list-item-content>
              <v-list-item-title>患者档案</v-list-item-title>
              <v-card class="mx-auto" >
                    <v-card-text>
                    <div class="text--primary">
                        <span class="tit" >1. 姓名 </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill > {{ file.name }} </v-chip>
                        <br>
                        <span class="tit" >2. 年龄 </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill > {{ file.birthday | time }} </v-chip>
                        <br>
                        <span class="tit" >3. 身高 </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill > {{ file.height }}cm </v-chip>
                        <br>
                        <span class="tit" >4. 体重 </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill > {{ file.weight }}kg </v-chip>
                        <br>
                        <br>
                        <hr>
                        <br>
                        <span class="tit" >5. 婚姻 </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill > {{ file.marriage==0?'未婚':"已婚" }} </v-chip>
                        <br>
                        <span class="tit" >6. 是否有子女 </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill > {{ file.breeding==0?"无子女":'有子女' }} </v-chip>
                        <br>
                        <span class="tit" >7. 性生活是否有规律 </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill > {{ file.sexual_life==0?'不规律':'规律' }} </v-chip>
                        <br>
                        <span class="tit" >8. 是否有晨勃 </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill > {{ file.morning_wood==0?'无晨勃':'有晨勃' }} </v-chip>
                        <br>
                        <span class="tit" >9. 性刺激下是否有勃起 </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill > {{ file.sexual_stimulus==0?'无勃起':'有勃起' }} </v-chip>
                        <br>
                        <span class="tit" >10. 病程持续时间 </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill > {{ file.duration }} </v-chip>
                        <br>
                        <span class="tit" >11. 伴随疾病  </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill v-for="item in file.disease" :key="item" > {{ item }} </v-chip>
                        <br>
                        <span class="tit" >12. 手术外伤史  </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill v-for="item in file.trauma" :key="item" > {{ item }} </v-chip>
                        <v-chip class="ma-2" outlined pill v-if="file.trauma.length == 0" > 无 </v-chip>
                        <br>
                        <span class="tit" >13. 吸烟史  </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill >
                            <span v-if="file.smoke == 0">从不</span>
                            <span v-else-if="file.smoke == 1">不经常</span>
                            <span v-else-if="file.smoke == 2">经常</span>
                            <span v-else-if="file.smoke == 3">每天</span>
                        </v-chip>
                        <br>
                        <span class="tit" >14. 饮酒史  </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill >
                            <span v-if="file.drink == 0">从不</span>
                            <span v-else-if="file.drink == 1">不经常</span>
                            <span v-else-if="file.drink == 2">经常</span>
                            <span v-else-if="file.drink == 3">每天</span>
                        </v-chip>
                        <br>
                        <span class="tit" >15. 服药史  </span> 
                        <br>
                        <v-chip class="ma-2 primary primary--text" outlined pill v-for="item in file.medicine" :key="item"  > {{ item }} </v-chip>
                        <v-chip class="ma-2" outlined pill v-if="file.medicine.length == 0" > 无 </v-chip>
                        <br>
                    </div>
                    </v-card-text>
                    <v-card-actions>
                    </v-card-actions>
                </v-card>
            </v-list-item-content>
</template>

<script>
export default {
    name:'EHS',
    props:{
        file:{}
    },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.tit{
    font-size: 16px;
    color: #000;
}
.v-card__text{
    padding-left: 50px;
}
.v-list-item__title{
    padding-left: 50px;
}
</style>